var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7618 6.94V13H13.2978V12.064C13.1058 12.4 12.8498 12.656 12.5298 12.832C12.2098 13.008 11.8418 13.096 11.4258 13.096C11.1618 13.096 10.9178 13.052 10.6938 12.964V15.592H9.20578V6.94H10.6938V10.612C10.6938 11.052 10.7818 11.376 10.9578 11.584C11.1418 11.792 11.4218 11.896 11.7978 11.896C12.2378 11.896 12.5898 11.752 12.8538 11.464C13.1178 11.176 13.2498 10.792 13.2498 10.312V6.94H14.7618Z",
    fill: "#1D6295"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/average.bb304f312806320bd07ee54dfaff1e7d.svg";
export { ForwardRef as ReactComponent };